<template>
  <div
    class="wrapper"
    style="
      min-width: 100%;
      height: 100vh;
      padding-top: 0px;
      margin: 0;
      background-color: #e5e5e5;
    "
  >
    <div class="EntryError text-center" v-if="!isLoading">
      <div
        class="errorMsg"
        v-if="!bookingDetails.entryStarted && !bookingDetails.entryClosed"
      >
        Entries Not Started Yet!
      </div>

      <div
        class="errorMsg"
        v-else-if="bookingDetails.entryStarted && bookingDetails.entryClosed"
      >
        Entries Are Now Closed!
      </div>

      <div class="successMsg" v-else>
        <img src="@/assets/img/valid.svg" />
        Valid Entry
      </div>
    </div>

    <section class="movie_details_new" v-if="!isLoading">
      <div class="movie_name_new padding-top">
        <h6>
          {{ bookingDetails.movie_title }}
          <span style="font-weight: 500">
            ({{ bookingDetails.lang_version }})
          </span>
        </h6>

        <span class="dimension">{{ bookingDetails.mf_name }}</span>
      </div>

      <div class="second_section">
        <div class="padding-top">
          <h5 class="font" style="text-align: start">
            {{ bookingDetails.ss_start_show_time }}
          </h5>
        </div>

        <div>
          <img src="@/assets/img/Vertical.svg" class="img_vertical" />
        </div>

        <div class="padding-top">
          <h5 class="font" style="text-align: end">
            {{ bookingDetails.screen_name }}
          </h5>
        </div>
      </div>
    </section>

    <section class="tickets_sec" v-if="!isLoading">
      <div class="">
        <div class="content">
          <small class="text-muted" style="text-transform: uppercase">
            Seats
            <!--Seats Count{{
                bookingDetails.seats && bookingDetails.seats.length > 0
                  ? "(" + bookingDetails.seats.length + ")"
                  : ""
              }}--->
          </small>

          <span
            v-if="bookingDetails.isPrivateShow === true"
            class="content-text"
          >
            Entire Hall Booked
          </span>

          <span
            style=""
            class="content-text"
            v-for="(singleSeat,
            singleSeatIndex) in bookingDetails.arrayOfTicketTypes"
            :key="singleSeatIndex"
          >
            <!-- {{ bookingDetails.seats ? bookingDetails.seats.toString() : "" }} -->

            <div style="" class="content-text">
              {{ singleSeat.count }} {{ singleSeat.tt_name
              }}{{
                singleSeatIndex !== bookingDetails.arrayOfTicketTypes.length - 1
                  ? ","
                  : ``
              }}
            </div>
          </span>

          <div class="content-text">
            {{
              bookingDetails.seats && bookingDetails.seats.length > 0
                ? "(" + bookingDetails.seats.length + ")"
                : ""
            }}
          </div>
        </div>

        <!---Seat selection--->

        <div class="btn_count_wrapper" v-if="!bookingDetails.isPrivateShow">
          <button
            @click="onSelectValue('All')"
            :class="selectedValue == 'All' ? 'selected' : ''"
            class="btn-count"
          >
            All
          </button>

          <button
            v-for="(singleSeat, loopKey) in seats"
            :key="loopKey"
            @click="onSelectValue(singleSeat)"
            :class="
              singleSeat.disabled
                ? 'seat-disabled'
                : singleSeat.selected == true
                ? 'selected'
                : ''
            "
            class="btn-count"
          >
            <!-- {{ singleSeat.sl_seat_name }} -->
            {{ getSeatLabel(singleSeat) }}
          </button>

          <!-- <button class="btn-count selected">2</button>
          <button class="btn-count">3</button>
          <button class="btn-count">4</button>-->
        </div>

        <div
          v-if="bookingDetails.isPrivateShow === true"
          class="d-flex justify-content-center my-4"
        >
          <button class="plus-minus-btn" @click="handleAdmitChange('sub')">
            -
          </button>

          <input
            type="number"
            v-model="currentAdmits"
            :min="0"
            class="flex-grow-1 form-control"
            @change="handleInputChange"
          />

          <button class="plus-minus-btn" @click="handleAdmitChange('add')">
            +
          </button>
        </div>

        <!---Seat selection--->
      </div>

      <div class="btn_check_main">
        <!--img src="@/assets/img/Tick.svg" v-if="buttonchange()"--->

        <button
          id="btn-chg"
          @click="
            isMifClient ? showPrintOption(true) : checkSubmitAvailable(true)
          "
          class="btn-scan btn-confirm check_btn"
          :class="
            (!bookingDetails.isPrivateShow && selectedValue.length == 0) ||
            disableConfirmed == true ||
            (bookingDetails.isPrivateShow === true && currentAdmits == 0)
              ? 'disabled'
              : ''
          "
        >
          Check-In
        </button>
      </div>
    </section>

    <section class="age_restriction" v-if="!isLoading">
      <div v-if="bookingDetails.age_limit != undefined">
        <div class="age-rating-new">
          <div
            :class="'age-circle'"
            :style="
              'background-color:' + getAgeColor(bookingDetails.age_limit) + ';'
            "
          >
            <span style="font-size: 30px">
              <b>{{ bookingDetails.age_limit }}</b>
            </span>

            <br />
            <span style="font-size: 15px"><b>Age</b></span>
          </div>

          <p class="dob">DOB {{ "<" }} {{ bookingDetails.earliest_bday }}</p>
        </div>
      </div>
    </section>

    <section
      class="swapAlert p-4 mx-auto w-100"
      v-if="
        bookingDetails.hasOwnProperty('swapAlert') &&
          bookingDetails.swapAlert &&
          bookingDetails.hasOwnProperty('swapDetails') &&
          bookingDetails.swapDetails &&
          bookingDetails.swapDetails.length > 0
      "
    >
      <b-alert show variant="warning">
        <h5 class="alert-heading">{{ "Re-Scheduled Alert! " }}</h5>

        <p v-if="bookingDetails.swap_type == 1" class="fs-14">
          Show Shifted from
          <span class="font-weight-bold">
            {{ bookingDetails.swapDetails[0].screen_name }}
          </span>
          to
          <span class="font-weight-bold">{{ bookingDetails.screen_name }}</span>
        </p>

        <p v-if="bookingDetails.swap_type == 2" class="fs-14">
          Show
          <span class="font-weight-bold">
            {{ bookingDetails.swapDetails[0].ss_start_show_time }} -
            {{ bookingDetails.swapDetails[0].ss_end_show_time }} |
            {{ bookingDetails.swapDetails[0].screen_name }}
          </span>
          has been re-schedule to
          <span class="font-weight-bold">
            {{ bookingDetails.ss_start_show_time }} -
            {{ bookingDetails.ss_end_show_time }} |
            {{ bookingDetails.screen_name }}
          </span>
        </p>
      </b-alert>
    </section>

    <section
      class="d-block"
      style="margin-bottom: 20px"
      v-if="
        bookingDetails &&
          bookingDetails.mf_name &&
          bookingDetails.mf_name.includes('4dx')
      "
    >
      <div class="instruction">
        <img src="@/assets/img/women.svg" />

        <p>
          Pregnant Woman
          <span style="color: red">not allowed</span>
          for 4DX shows
        </p>
      </div>

      <div class="instruction">
        <img src="@/assets/img/food.svg" />

        <p>
          Food & Beverage
          <span style="color: red"> not allowed</span>
          for 4DX shows
        </p>
      </div>
    </section>

    <section>
      <center>
        <footer class="footer">
          <div class="footer-sec">
            <div class="mx-4" @click="goToShow()">
              <img src="@/assets/img/reel.svg" />
            </div>

            <div class="mx-4" @click="goHome()">
              <img src="@/assets/img/scanner.svg" />
            </div>

            <div class="mx-4" @click="onLogout">
              <img src="@/assets/img/logout.svg" />
            </div>
          </div>
        </footer>
      </center>
    </section>

    <section class="section-movie-details" style="display: none">
      <div>
        <div class="movie-name float-right p-4">
          {{ bookingDetails.cine_name }}
        </div>

        <div class="movie-name">{{ bookingDetails.movie_title }}</div>

        <div class="movie-details">
          <span>{{ bookingDetails.rating }}</span>

          <span>|</span>

          <span>{{ bookingDetails.lang_name }}</span>

          <span>{{ bookingDetails.mf_name }}</span>
        </div>

        <p>{{ bookingDetails.cine_address }}</p>

        <hr />

        <div class="row mx-0">
          <div class="w-50 pr-3">
            <small class="text-muted">Date:</small>

            <h6>{{ bookingDetails.showdate }}</h6>
          </div>

          <div class="w-50">
            <small class="text-muted">Time:</small>

            <h6>{{ bookingDetails.ss_start_show_time }}</h6>
          </div>
        </div>

        <hr />

        <div class="row mx-0">
          <div class="w-50">
            <small class="text-muted">Amount:</small>

            <h6>
              {{ currencyData.curr_code }} {{ bookingDetails.sb_total_amount }}
            </h6>
          </div>

          <div class="w-50">
            <small class="text-muted">
              Seats : -
              {{
                bookingDetails.seats && bookingDetails.seats.length > 0
                  ? "(" + bookingDetails.seats.length + ")"
                  : ""
              }}
            </small>

            <br />

            <span v-if="bookingDetails.isPrivateShow === true">
              Entire Hall Booked
            </span>

            <span
              style="display: inline"
              v-for="(singleSeat,
              singleSeatIndex) in bookingDetails.arrayOfTicketTypes"
              :key="singleSeatIndex"
            >
              <div style="display: inline">
                {{ singleSeat.count }} {{ singleSeat.tt_name
                }}{{
                  singleSeatIndex !==
                  bookingDetails.arrayOfTicketTypes.length - 1
                    ? ","
                    : ``
                }}
              </div>
            </span>
          </div>
        </div>
      </div>

      <button
        :class="
          `btn-scan btn-fixed ${
            bookingDetails.isPrivateShow === true ? 'private-show-btn' : ''
          }`
        "
        v-b-modal.modal-1
      >
        Check In/Scan Again
      </button>
    </section>

    <!--Modal-->

    <b-modal id="modal-1" ref="modal1" centered hide-footer hide-header>
      <div class="text-center py-4">
        <div class="mb-4">
          <img src="@/assets/img/check.svg" height="125" width="125" alt />
        </div>

        <h5 class="font-weight-bold">Check in successful</h5>

        <h5 class="font-weight-bold">How many people?</h5>

        <div class="btn_count_wrapper" v-if="!bookingDetails.isPrivateShow">
          <button
            @click="onSelectValue('All')"
            :class="selectedValue == 'All' ? 'selected' : ''"
            class="btn-count"
          >
            All
          </button>

          <button
            v-for="(singleSeat, loopKey) in seats"
            :key="loopKey"
            @click="onSelectValue(singleSeat)"
            :class="
              singleSeat.disabled
                ? 'seat-disabled'
                : singleSeat.selected == true
                ? 'selected'
                : ''
            "
            class="btn-count"
          >
            <!-- {{ singleSeat.sl_seat_name }} -->
            {{ getSeatLabel(singleSeat) }}
          </button>
        </div>

        <div
          v-if="bookingDetails.isPrivateShow === true"
          class="d-flex justify-content-center my-4"
        >
          <button class="plus-minus-btn" @click="handleAdmitChange('sub')">
            -
          </button>

          <input
            type="number"
            v-model="currentAdmits"
            :min="0"
            class="flex-grow-1 form-control"
            @change="handleInputChange"
          />

          <button class="plus-minus-btn" @click="handleAdmitChange('add')">
            +
          </button>
        </div>

        <!-- REMOVE CLASS "DISABLED" ONCE NO OF PEOPLE ARE SELECTED -->

        <button
          @click="
            isMifClient ? showPrintOption(true) : checkSubmitAvailable(false)
          "
          class="btn-scan btn-confirm"
          :class="
            (!bookingDetails.isPrivateShow && selectedValue.length == 0) ||
            disableConfirmed == true ||
            (bookingDetails.isPrivateShow === true && currentAdmits == 0)
              ? 'disabled'
              : ''
          "
        >
          Confirm
        </button>

        <button @click="goHome()" class="mt-3 btn-scan btn-confirm">
          Go Home
        </button>
      </div>
    </b-modal>

    <b-modal id="EntryMsg" ref="EntryMsg" centered hide-footer hide-header>
      <div class="text-center py-4">
        <div class="">
          <img src="@/assets/img/warning-icon.svg" height="75" width="75" alt />
        </div>

        <h5 class="font-weight-bold text-warning">Warning!</h5>

        <p class="text-danger font-weight-bold">
          Entry From this Gate is Not Allowed for Some Seats!
        </p>

        <table class="table border" border="1">
          <thead>
            <tr>
              <th scope="col">Seat</th>

              <th scope="col">Description</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(eSeat, eSeatIndex) in ErrorSeatsComputed"
              :key="eSeatIndex"
            >
              <td class="font-weight-bold">
                <div class="d-flex flex-wrap" style="word-break: break-word">
                  {{ eSeat[1].map(x => x.sl_seat_name).join(",") }}
                </div>
              </td>

              <td>{{ eSeat[1][0].entry_description || "-" }}</td>
            </tr>
          </tbody>
        </table>

        <button
          @click="onSubmitSeats(privateShowprops)"
          class="mt-3 btn-scan btn-confirm btn-sm btn-danger w-50 mx-auto"
        >
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="noEntryAvailable"
      ref="noEntryAvailable"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <div class="">
          <img src="@/assets/img/warning-icon.svg" height="75" width="75" alt />
        </div>

        <h5 class="font-weight-bold text-warning">Warning!</h5>

        <p class="text-danger font-weight-bold">
          Entries Not Available From this Gate!
        </p>

        <div class="">
          {{
            ErrorSeats &&
              ErrorSeats.length > 0 &&
              ErrorSeats[0].entry_description
          }}
        </div>

        <button
          @click="gotoHome()"
          class="mt-3 btn-scan btn-confirm btn-sm w-50 mx-auto btn-danger"
        >
          Home
        </button>
      </div>
    </b-modal>

    <b-modal
      id="ticketPrintConfirmation"
      ref="ticketPrintConfirmation"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      no-fade
    >
      <div class="text-center py-4">
        <div class="">
          <img src="@/assets/img/printer.svg" height="50" width="50" alt />
        </div>
        <p class="font-weight-bold mt-1">
          Would you like to print the ticket ?
        </p>

        <div class="d-flex justify-content-between align-items-center">
          <button
            @click="checkSubmitAvailable(false, true)"
            class="mt-3 mr-3 btn-scan btn-confirm btn-sm px-5 btn-success"
          >
            Yes
          </button>
          <button
            @click="checkSubmitAvailable(false, true)"
            class="mt-3 mr-3 btn-scan btn-confirm btn-sm px-5 btn-danger"
          >
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="successMsgModal"
      ref="successMsgModal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <div class="mb-3">
          <img src="@/assets/img/check.svg" height="75" width="75" alt />
        </div>
        <p class="font-weight-bold">{{ successModalMessage }}</p>
        <button
          @click="closeSuccessModal"
          class="mt-3 btn-scan btn-confirm btn-sm w-50 mx-auto"
        >
          Close
        </button>
      </div>
    </b-modal>

    <div style="" class="d-none" ref="print_boxoffice_fnb_ticket">
      <div v-html="EjsData"></div>
    </div>

    <!-- <ErrorModal
      v-model="isErrorModalVisible"
      title="Guest Already Entered"
      size="lg"
      :close-on-backdrop="false"
      @close="handleCustomModalClose"
    >
    </ErrorModal> -->
    <ErrorModal
      v-model="isErrorModalVisible"
      :title="errorModalMessage"
      size="lg"
      :close-on-backdrop="false"
    >
    </ErrorModal>

    <!--Modal-->
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
import { URL_BASE as BASEURL } from "@/helper/constants";
import constant from "@/helper/constant";
import { getLangSpecificAttribute } from "@/helper/Languages";
import _ from "lodash";
import ErrorModal from "../components/errorModal.vue";
// var moment = require("moment");
import Printd from "printd";

import moment from "moment";
export default {
  name: "TicketDetails",
  // props: ["qrcode"],
  data() {
    return {
      EjsData: null,
      isErrorModalVisible: false,
      errorModalTitle: "Error",
      errorModalMessage: "",
      isQfxCinema: "",
      // BASEURL: URL_BASE,
      bookingDetails: {},
      seat: "",
      seats: [],
      qrcode: "",
      selectedValue: "All",
      currencyData: [],
      disableConfirmed: false,
      MovieContentArtworks: [],
      currentAdmits: 0,
      remainingAdmits: 0,
      isLoading: false,
      noEntryAvailable: false,
      someEntrynotAvailable: false,
      ErrorSeats: [],
      privateShowprops: false,
      successModalMessage: "",
      successRedirectTimeout: null
    };
  },
  components: {
    ErrorModal
  },
  computed: {
    ErrorSeatsComputed() {
      let tempArr = [];
      if (this.ErrorSeats.length > 0) {
        tempArr = _.toPairs(
          _.groupBy(this.ErrorSeats.filter(x => x), "entry_id")
        );
      }

      console.log("tempArr", tempArr);
      return tempArr;
    },
    isMifClient() {
      return window.localStorage.getItem("CLIENT_NAME").toLowerCase() === "mif";
    },
    isNovo01Mall() {
      const client = (
        window.localStorage.getItem("CLIENT_NAME") || ""
      ).toLowerCase();
      const cinemaId = Number(
        this.bookingDetails.cine_id || this.bookingDetails.cinema_id
      );
      const cinemaName = (this.bookingDetails.cine_name || "")
        .trim()
        .toLowerCase();

      return (
        client === "novocinemas" && cinemaId === 3 && cinemaName === "01 mall"
      );
    }
  },
  beforeMount: function() {
    let code = String(this.$route.query.qrcode);
    // console.log("this.$route.query.qrcode", this.$route.query.qrcode);
    if (code.includes("http")) {
      //find the booking code in the url - https://cinematic-server-imaculix-1.brij.tech/your-ticket/OVXAF5KPGMP
      // if (code.includes("qfx")) {
      //   let isQfxCinema = this.isQfxCinema;
      //   isQfxCinema == true;
      //   console.log("isQfxCinema", isQfxCinema);
      // }

      code = code.split("/");
      // console.log("code", code);
      this.qrcode = code[code.length - 1];
      // console.log("this.qrcode", this.qrcode);
    } else {
      this.qrcode = code;
    }
    // console.log(
    //   window.localStorage.getItem("CLIENT_NAME").toLowerCase() === "mif",
    //   "MIF Cliet"
    // );
    // console.log(this.isMifClient, "this.isMifClient");
    // console.log("code123", code);
    if (this.qrcode) {
      this.getBookingDetails(this.qrcode);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {
    this._GetGlobalOptions().then(() => {
      this.getCurrencyCode();
    });
  },
  beforeDestroy() {
    clearTimeout(this.successRedirectTimeout);
  },
  methods: {
    goToShow() {
      this.$router.push({
        name: "showtime",
        path: "/showtime"
      });
    },
    getAgeColor(age) {
      let color = `#FAFAFA`;
      if (age < 6) {
        color = "#FAFAFA";
      } else if (age >= 6 && age < 12) {
        color = "#FDC500";
      } else if (age >= 12 && age < 16) {
        color = "#12A437";
      } else if (age >= 16 && age < 18) {
        color = "#009FDB";
      } else if (age >= 18) {
        color = "#E40313";
      }

      return color;
    },
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login"
      });
      return window.caches.keys();
    },
    getLangSpecificAttribute,
    handleAdmitChange: function(type) {
      if (type === "add") {
        if (parseInt(this.currentAdmits) + 1 <= parseInt(this.remainingAdmits))
          this.currentAdmits = parseInt(this.currentAdmits) + 1;
        else this.$toasted.show("Reached Max Seat Limit In Audi");
      } else if (type === "sub") {
        if (parseInt(this.currentAdmits) - 1 >= 0)
          this.currentAdmits = parseInt(this.currentAdmits) - 1;
      }
    },
    handleInputChange($event) {
      let num = parseInt($event.target.value);
      if (num < 0) {
        this.$toasted.show("Cannot have negative values");
        this.currentAdmits = 0;
      } else if (num > parseInt(this.remainingAdmits)) {
        this.$toasted.show("Exceeded Seat Limit in Audi");
        this.currentAdmits = 0;
      }
    },
    onSelectValue: function(value) {
      // console.log("test1", value.ssb_id);
      if (value == "All") {
        this.selectedValue = "All";
        this.seats = this.seats.map(seat => {
          seat.selected = false;
          return seat;
        });
      } else {
        this.selectedValue = "selected";
        this.seats = this.seats.map(seat => {
          // console.log("test2", value.ssb_id, seat.ssb_id);
          if (seat.ssb_id == value.ssb_id && !seat.disabled) {
            seat.selected = !seat.selected;
          }
          return seat;
        });
      }

      let count = 0;
      this.seats.map(seat => {
        if (seat.selected == true) {
          count++;
        }
      });
      if (count == 0 && this.selectedValue != "All") {
        this.selectedValue = "";
      }
    },
    _GetImagePath(imagePath) {
      console.log("imagePa :", imagePath);
      return imagePath;
      // if (imagePath) {
      //   if (imagePath.match(/S3\//g)) {
      //     return `${constant.imageS3BaseURL}${imagePath}`;
      //   } else {
      //     return `${constant.imageBaseURL}${imagePath}`;
      //   }
      // }
    },
    _GetGlobalOptions: function() {
      return new Promise((resolve, reject) => {
        BookingService.GetGlobalOptions()
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              data.Records.map(x => {
                if (x.go_key === "ORGANIZATION_NAME") {
                  window.localStorage.setItem("isCinemaName", x.go_value);
                }
                if (x.go_key === "CURRENCY") {
                  window.localStorage.setItem("BRGLOPCUR", x.go_value);
                  window.localStorage.setItem("BRGLOPCU", x);
                } else if (x.go_key === "APPLICATION_LANGUAGE") {
                  window.localStorage.setItem("BRGLOPAL", x.go_value);
                } else if (x.go_key === "OPERATION_COUNTRY") {
                  window.localStorage.setItem("BRGLOPCO", x.go_value);
                }
              });
              resolve("data.Records");
            } else {
              // Show Error
              console.log("data.message :", data.message);
              reject(data.message);
            }
          })
          .catch(error => {
            //Catch Error
            console.log("catch error on GetGlobalOptions :", error);
            reject("catch error on GetGlobalOptions");
          });
      });
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: window.localStorage.getItem("BRGLOPCUR")
      };
      BookingService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    gotoHome() {
      this.$router.push({
        name: "qrCode"
      });
    },
    closeSuccessModal() {
      clearTimeout(this.successRedirectTimeout);
      this.$refs.successMsgModal.hide();
      this.disableConfirmed = false;
      const cinemaName = window.localStorage.getItem("isCinemaName") || "";
      if (cinemaName.includes("QFX")) {
        this.$router.push({ name: "manual" });
      } else {
        this.$router.push({ name: "qrCode" });
      }
    },
    showPrintOption(privateShow = false) {
      // Previously this was the condition this.bookingDetails["print_taken_type"] != "BO"
      if (
        this.bookingDetails.hasOwnProperty("print_taken_type") &&
        this.bookingDetails.print_taken_type
      ) {
        this.$refs.ticketPrintConfirmation.show();
        this.privateShowprops = privateShow;
      } else {
        this.checkSubmitAvailable(privateShow, false);
      }
    },
    checkSubmitAvailable(privateShow = false, printTicket = false) {
      if (this.ErrorSeats.length > 0 && this.selectedValue == "All") {
        this.$refs.EntryMsg.show();
        this.privateShowprops = privateShow;
      } else {
        this.onSubmitSeats(privateShow, printTicket);
      }
    },
    onSubmitSeats: function(privateShow = false, printTicket = false) {
      this.disableConfirmed = true;
      const clientSetupName = window.localStorage.getItem("CLIENT_NAME") || "";

      const cinemaName = window.localStorage.getItem("isCinemaName") || "";
      let seatsSelected = this.seats.filter(x => {
        if (x.selected == true) {
          return x.ssb_id;
        }
      });
      let payload = {
        seats: !this.bookingDetails.isPrivateShow
          ? this.selectedValue == "All"
            ? this.bookingDetails.seatArrayForQrCode.filter(x => !x.disabled)
            : seatsSelected
          : [],
        booking_id: this.qrcode,
        isPrivateShow: this.bookingDetails.isPrivateShow,
        current_admits: parseInt(this.currentAdmits)
      };
      BookingService.updateSeatOccupancy(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            // this.$toasted.show(data.message);
            this.$refs.modal1.hide();
            this.successModalMessage = data.message || "Seats status updated";
            this.$refs.successMsgModal.show();
            let code = String(this.$route.query.qrcode);
            console.log("clientSetupName", clientSetupName);
            console.log(
              "clientSetupName.includes",
              clientSetupName.includes("mif")
            );

            if (printTicket && clientSetupName.includes("mif")) {
              let checkAllSeatEntered =
                this.bookingDetails["seatArrayForQrCode"].length ==
                payload["seats"].length;
              this.getSingleBoFnbApi(payload["seats"], checkAllSeatEntered);
            }
            // setTimeout(() => {
            //   this.disableConfirmed = false;

            //   if (cinemaName.includes("QFX")) {
            //     this.$router.push({
            //       name: "manual"
            //     });
            //   } else {
            //     this.$router.push({
            //       name: "qrCode"
            //     });
            //   }
            // }, 3000);
            this.successRedirectTimeout = setTimeout(() => {
              this.closeSuccessModal();
            }, 8000);

            if (privateShow) {
              this.buttonchange();
            }
          } else {
            this.disableConfirmed = false;
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.$toasted.show(err.response.data.message);
          } else {
            this.$toasted.show("something went wrong");
          }
          // this.$toasted.show("something went wrong");
        });
    },
    getSingleBoFnbApi: async function(seats, allSeatEntered = false) {
      var userAgent = navigator.userAgent.toLowerCase();
      let sb_id = this.bookingDetails.hasOwnProperty("sb_id")
        ? this.bookingDetails.sb_id
        : null;
      let ft_id = this.bookingDetails.hasOwnProperty("ft_id")
        ? this.bookingDetails.ft_id
        : null;

      const enteredType = allSeatEntered ? 1 : 2;
      const ssbIdsArray = seats.map(se => se.ssb_id).join(",");
      if (userAgent.indexOf(" electron/") > -1) {
        console.log(userAgent, "userAgent");
        console.log("this.$socket", this.$socket);
        try {
          this.$socket.emit("on_print_ticket", {
            ttype: "dynamicURL",
            dataURL: `${BASEURL}/api/print-bo-fnb-ticket/${sb_id}/${ft_id}?ticket_print_type=${null}&print_taken_type=${"SCAN"}&ssbIdsArray=${ssbIdsArray}&enteredtype=${enteredType}`
          });
        } catch (error) {
          console.log(error, "from common api ticket");
        }
      } else {
        try {
          const response = await BookingService.getBoFnbSingleTicketApi({
            sb_id: sb_id,
            ft_id: ft_id,
            ticket_print_type: null,
            ssbIdsArray: ssbIdsArray,
            enteredType: enteredType
          });
          const { data } = response;
          if (data) {
            this.EjsData = data;
          }
          this.$nextTick(() => {
            const p = new Printd();
            p.print(this.$refs.print_boxoffice_fnb_ticket, []);
          });
        } catch (error) {
          console.log(error, "from common api ticket webb");
        }
      }
    },
    buttonchange: function() {
      document.getElementById("btn-chg").innerText = "Checked-In";
      document.getElementById("btn-chg").style.backgroundColor = "#00B60C";
    },
    goHome: function() {
      this.$router.push({
        name: "qrCode"
      });
    },
    sortSeatsString(seatA, seatB) {
      let a = seatA.sl_seat_name;
      let b = seatB.sl_seat_name;
      let reA = /[^a-zA-Z]/g;
      let reN = /[^0-9]/g;
      let aA = a.replace(reA, "");
      let bA = b.replace(reA, "");
      if (aA === bA) {
        let aN = parseInt(a.replace(reN, ""), 10);
        let bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    },
    getBookingDetails(booking_id) {
      let loader = this.$loading.show();
      this.isLoading = true;
      this.noEntryAvailable = false;
      this.someEntrynotAvailable = false;

      let payload = { booking_code: booking_id };
      BookingService.GetBookingDetails(payload)
        .then(response => {
          // console.log("response :", response);

          const { data } = response;
          if (data.status && data.Records.result.length > 0) {
            this.bookingDetails = data.Records.result[0];
            // console.log("this.bookingDetails :", data.Records.result[0]);
            this.remainingAdmits = this.bookingDetails.remainingAdmits || 0;
            this.MovieContentArtworks = data.MovieContentArtworks;
            let count = 0;
            this.ErrorSeats = [];
            this.seats = data.Records.result[0].seatArrayForQrCode.map(seat => {
              if (
                window.localStorage.getItem("SEID") &&
                window.localStorage.getItem("SEID") != null &&
                seat.entry_id
              ) {
                let SEID = window.localStorage.getItem("SEID");
                if (SEID.toLowerCase() != seat.entry_id.toLowerCase()) {
                  count++;
                  this.ErrorSeats.push(seat);
                  seat.disabled = true;
                } else {
                  seat.disabled = false;
                }
              } else {
                seat.disabled = false;
              }
              seat.selected = false;
              return seat;
            });

            if (count && count == this.seats.length) {
              this.noEntryAvailable = true;
              this.$refs.noEntryAvailable.show();
            } else if (count > 0) {
              this.someEntrynotAvailable = true;
            }
            var date = this.bookingDetails.ss_start_date.split("T");
            // this.bookingDetails.showdate = moment(date[0]).format(
            //   "ddd DD MMM YYYY"
            // );

            // this.seats = this.seats.sort((a, b) => {
            //   return a.sl_seat_name - b.sl_seat_name;
            // });

            // this.seats = _.sortBy(this.seats, "sl_seat_name");
            let self = this;
            this.seats = this.seats.sort(self.sortSeatsString);

            // console.log("this.seats", this.seats);

            this.bookingDetails.showdate = moment(
              this.bookingDetails.ss_start_date
            ).format("ddd DD MMM YYYY");
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.errorModalMessage = data.message || "Something went wrong";
            this.isErrorModalVisible = true;
            // this.$toasted.show(
            //   data.message
            //     ? "No Data Found for particular QR code or you have already entered"
            //     : data.message
            // );
            // setTimeout(() => {
            //   this.$router.go(-1);
            // }, 3500);
          }
        })
        .catch(error => {
          console.log("Error", error);
          this.isLoading = false;
          this.errorModalMessage = "Something went wrong";
          this.isErrorModalVisible = true;
          //   this.$toasted.show("Something went wrong");
          setTimeout(() => {
            this.$router.go(-1);
          }, 3000);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getSeatLabel(seat) {
      if (!this.isNovo01Mall) return seat.sl_seat_name;

      const row =
        seat.sl_row_name !== undefined &&
        seat.sl_row_name !== null &&
        String(seat.sl_row_name).trim() !== ""
          ? seat.sl_row_name
          : seat.sl_row_num;

      const hasRow =
        row !== undefined && row !== null && String(row).trim() !== "";
      return hasRow ? `${row}-${seat.sl_seat_name}` : seat.sl_seat_name;
    }
  }
};
</script>

<style>
.ratingAge {
  margin-bottom: 10px !important;
  font-size: 16px !important;
  padding: 6px !important;
  width: 100%;
}

.EntryError {
  /*margin-top: 40px;*/
  color: white;
  font-weight: bold;
  font-size: 20px;
  /*padding: 5px;*/
}

.EntryError .errorMsg {
  background-color: red;
  padding: 6px;
}

.EntryError .successMsg {
  background-color: green;
  padding: 6px;
}

.private-show-btn {
  background-color: #f2c94c;
}

.h-50 {
  height: 50px !important;
}

.w-60 {
  width: 60px !important;
}

.plus-minus-btn {
  background-color: #fff;
  border: 1px solid #3876d2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  padding: 0 10px;
  height: 40px;
  flex: 0 0 auto;
  width: 40px;
  margin: 0 15px;
  border-radius: 8px;
  color: #3876d2;
}
.movie_details_new {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  margin: 10px;
  /*padding: 12px;*/
}
.movie_name_new {
  text-align: center;
  border-bottom: 1px solid #e7e7e7;
  white-space: break-spaces;
  padding-bottom: 10px;
}
.movie_name_new h6 {
  font-weight: bold;
  text-transform: uppercase;
}
.second_section {
  /*display: flex;
  justify-content: space-around;
  align-items: center;*/
  display: flex; /*grid */
  /* grid-template-columns: 100px 10px 100px; */
  justify-content: space-between;
  /* text-align: center; */
  padding: 0 45px;
}
.font {
  font-size: 25px;
  font-weight: bold;
}
.padding-top {
  padding-top: 10px;
}
.img_vertical {
  background: #e7e7e7;
}
.tickets_sec {
  /*display: flex;*/
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  margin: 10px;
}
.content {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
}
.content-text {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}
.btn_check_main {
  display: flex;
  justify-content: center;
  align-content: center;
}
.check_btn {
  color: white;
  text-transform: uppercase;
  background-color: #032d6e;
  border: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 15px;
  width: 100%;
  text-transform: uppercase;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  display: flex;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.footer-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  background-color: white;
  padding: 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.age-circle {
  border: 3px solid black;
  background-color: yellow;
  color: black;
  border-radius: 50%;
  padding: 10px 30px;
  text-align: center;
}
.dob {
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 10px;
  font-size: 17px;
}
.age-rating-new {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  background-color: rgb(229, 229, 229);
}
.instruction {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.dimension {
  background-color: black;
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  padding: 3px 13px;
  font-size: 12px;
}

.seat-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.instruction p {
  color: black;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/details.vue